import {
  MessageContext,
  defaultMessageContext,
} from "@/contexts/MessageContext";
import { memo } from "react";

import { IMessageContext } from "@/types/messageContext";

import { Messages } from "./Messages";
import { Thinking } from "./Message";
import { IMessageElement, IStep, type IAction } from "@/client/types";

interface Props {
  actions: IAction[];
  context: IMessageContext;
  elements: IMessageElement[];
  messages: IStep[];
}

const MessageContainer = memo(
  ({ actions, context, elements, messages }: Props) => {
    return (
      <MessageContext.Provider value={context || defaultMessageContext}>
        <Messages
          indent={0}
          messages={messages}
          elements={elements}
          actions={actions}
        />

        <Thinking indent={0} isLoading={context.loading} />
      </MessageContext.Provider>
    );
  }
);

export { MessageContainer };
